window.Products.DeviceCase.Iphone5 = function() {
};
window.Products.DeviceCase.Iphone5.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.Iphone5.id = 2;
window.Products.DeviceCase.Iphone5.slug = 'iphone5';

window.Products.DeviceCase.Iphone5.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.58;
	modelViewer.camera.position.z = 8;
};

window.Products.DeviceCase.Iphone5.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.8;
	controls.maxDistance = 3.8;
};